/**
 *  Modified to support different independent instances
 *  added un-subscription and mask change on the move
 *  jQuery numberMask Plugin
 *  27-04-2016
 */
;
(function ($) {
	'use strict';
	var pluginName = 'numberMask';
	var defaults = {
		type              : 'int',
		beforePoint       : 10,
		afterPoint        : 2,
		defaultValueInput : 0,
		allowNegative     : false,
		decimalMark       : ['.'],
		pattern           : ''
	};
	function _getUserAgent(){
		var isMobile = (function (a) {
			return /smart-tv|(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
		})(navigator.userAgent || navigator.vendor || window.opera);
		var  ua = navigator.userAgent, iPhone = /iphone/i.test(ua), chrome = /chrome/i.test(ua), android = /android/i.test(ua), winPhone = /Windows\sPhone|iemobile/i.test(ua);
		return {
			ua      : ua,
			iPhone  : iPhone,
			chrome  : chrome,
			android : android,
			winPhone : winPhone,
			useKeyPress : (!isMobile || (isMobile && iPhone && !winPhone))
		}
	}

	function Plugin(element, options) {
		this.element = element;
		this.$elm = $(element);
		this.ua = _getUserAgent();
		this.regExp = null;
		this.last_val = '';
		this.last_caret_position = {start : 0, end : 0};
		this.init(options);
	}

	function _getSelection(element) {
		var start = 0, end = 0, normalizedValue, range,
			textInputRange, len, endRange, statusSelection = false;

		if (typeof element.selectionStart == "number" && typeof element.selectionEnd == "number") {
			start = element.selectionStart;
			end = element.selectionEnd;
		} else {
			range = document.selection.createRange();

			if (range && range.parentElement() == element) {
				len = element.value.length;
				normalizedValue = element.value.replace(/\r\n/g, "\n");

				// Create a working TextRange that lives only in the input
				textInputRange = element.createTextRange();
				textInputRange.moveToBookmark(range.getBookmark());

				// Check if the start and end of the selection are at the very end
				// of the input, since moveStart/moveEnd doesn't return what we want
				// in those cases
				endRange = element.createTextRange();
				endRange.collapse(false);

				if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
					start = end = len;
				} else {
					start = -textInputRange.moveStart("character", -len);
					start += normalizedValue.slice(0, start).split("\n").length - 1;

					if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
						end = len;
					} else {
						end = -textInputRange.moveEnd("character", -len);
						end += normalizedValue.slice(0, end).split("\n").length - 1;
					}
				}
			}
		}
		if ((start - end) != 0) {
			statusSelection = true;
		}
		return {
			start           : start,
			end             : end,
			statusSelection : statusSelection
		};
	}

	function _setCaretPosition(element, caretPosStart, caretPosEnd) {
		if (element != null) {
			if (element.createTextRange) {
				var range = element.createTextRange();
				range.move('character', caretPosStart);
				range.select();
			} else {
				if (element.selectionStart) {
					element.focus();
					element.setSelectionRange(caretPosStart, caretPosEnd);
				} else {
					element.focus();
				}
			}
		}
	}

	function _getDecimalMarksString(options) {
		var decimalMarksString = '(\\' + options.decimalMark[0];
		for (var i = 1; i < options.decimalMark.length; i++) {
			decimalMarksString += "|\\" + options.decimalMark[i];
		}
		decimalMarksString += ')';
		return decimalMarksString;
	}

	Plugin.prototype.init = function (options) {
		if (options.decimalMark) {
			if ($.type(options.decimalMark) === "string")
				options.decimalMark = [options.decimalMark];
		}
		this.options = $.extend({}, defaults, options);

		if ((typeof this.options.pattern == "object") && (this.options.pattern instanceof RegExp)) {
			this.regExp = this.options.pattern;
		} else {
			var negRegExpPart = this.options.allowNegative ? "[-]?" : '',
				intRegExp = "^" + negRegExpPart + "\\d{1," + this.options.beforePoint + "}$",
				decimalRegExp = "^" + negRegExpPart + "\\d{1," + this.options.beforePoint + "}";
			decimalRegExp += _getDecimalMarksString(this.options);
			decimalRegExp += "\\d{0," + this.options.afterPoint + "}$";

			if (this.options.type == 'int') {
				this.regExp = new RegExp(intRegExp);
			} else {
				this.regExp = new RegExp(intRegExp + "|" + decimalRegExp);
			}
		}

		var self = this;

		this.element.onpaste = function (e) {
			var value = this.value;
			var selectionParam = _getSelection(e.target);
			var pastedText = undefined;

			if (window.clipboardData && window.clipboardData.getData) { // IE
				pastedText = window.clipboardData.getData('Text');
			} else if (e.clipboardData && e.clipboardData.getData) {
				pastedText = e.clipboardData.getData('text/plain');
			}
			var new_val = value.substring(0, selectionParam.start) + pastedText + value.substring(selectionParam.end);

			var isOK = (self.options.allowNegative && new_val === '-') || self.regExp.test(new_val);
			if (isOK) {
				self.last_val = new_val;
				this.value = new_val;
				var newCaretPosition = parseInt(selectionParam.start) + pastedText.length;
				_setCaretPosition(this, newCaretPosition, newCaretPosition);
			} else {
				return false;
			}
			return false;
		};

		this.onKeyUp = function (e) {
			var selectionParam = _getSelection(e.target);
			var value = e.target.value;
			if (value === "") {
				self.last_val = value;
			} else {
				var k = value.charCodeAt(selectionParam.start - 1);
				if (k) {
					var isOK = (self.options.allowNegative && value === '-') || self.regExp.test(value);
					if (isOK) {
						self.last_val = value;
					} else {
						e.target.value = self.last_val;
						_setCaretPosition(e.target, self.last_caret_position.start, self.last_caret_position.end);
					}
					return isOK;
				}
			}
		};

		this.onKeyDown = function (e) {
			var value = e.target.value;
			self.last_caret_position = _getSelection(e.target);
			var isOK = (self.options.allowNegative && value === '-') || self.regExp.test(value);
			if (isOK) {
				self.last_val = value;
			}
			return true;
		};

		this.onKeyPress = function (e) {
			var k = e.which;
			if (e.ctrlKey || e.altKey || e.metaKey || k < 32) {//Ignore
				return true;
			} else if (k) {
				var c = String.fromCharCode(k);
				var value = e.target.value;
				var selectionParam = _getSelection(e.target);
				value = value.substring(0, selectionParam.start) + c + value.substring(selectionParam.end);
				return (self.options.allowNegative && value === '-') || self.regExp.test(value);
			}
		};

		this.onBlur = function (e) {
			var input = $(e.target);
			if (input.val() != '') {
				input.val(self.formattedNumber());
			}
		};

		if( this.ua.useKeyPress ){
			this.$elm.on('keypress', this.onKeyPress);
		} else {
			this.$elm.on('keyup'  , this.onKeyUp);
			this.$elm.on('keydown', this.onKeyDown);
		}
		this.$elm.on('blur', this.onBlur);
	};

	Plugin.prototype.formattedNumber = function () {
		var val = this.$elm.val();
		if (this.regExp.test(val)) {
			return val;
		} else {
			return this.options.defaultValueInput;
		}
	};
	Plugin.prototype.setNumberMask = function (options) {
		this.unbindNumberMask();
		this.init(options);
	};
	Plugin.prototype.unbindNumberMask = function () {
		if (this.ua.useKeyPress) {
			this.$elm.off('keypress', this.onKeyPress);
		} else {
			this.$elm.off('keyup', this.onKeyUp);
			this.$elm.off('keydown', this.onKeyDown);
		}
		this.$elm.off('blur', this.onBlur);
		this.element.onpaste = function (e) {
			return true;
		};
	};
	Plugin.prototype.getNumberMask = function () {
		return this.options;
	};

	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			}
		});
	};
}(jQuery));